
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import { form7DataInfoType, affidavitInfoType } from '@/types/Information/Form7';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { hearingLocationsInfoType } from '@/types/Common';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form7";
const form7State = namespace("Form7");

import "@/store/modules/common";
const commonState = namespace("Common");

import AddAffidavitForm from './AddAffidavitForm.vue';

@Component({
    components:{        
        AddAffidavitForm        
    }
})
export default class Form7StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @commonState.State
    public hearingLocationsInfo!: hearingLocationsInfoType[];

    @form7State.State
    public form7Info: form7DataInfoType;

    @form7State.Action
    public UpdateForm7Info!: (newForm7Info: form7DataInfoType) => void  
    
    @form7State.State
    public currentNoticeOfUrgentApplicationId: string;

    @form7State.Action
    public UpdateCurrentNoticeOfUrgentApplicationId!: (newCurrentNoticeOfUrgentApplicationId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];    
    hearingLocationList: string[] = [];
    otherHearingLocationList: string[] = [];
    hearingLocation = "";
    otherHearingLocation = "";

    contestedOptions = [
        { text: 'Contested', value: true },
        { text: 'Uncontested', value: false }
    ];

    updated=0; 
    addAffidavitFormColor = 'court';
    AddNewAffidavitForm = false;
    latestEditAffidavitData;
    isEditAffidavitOpen = false;

    affidavitFields = [
        {
            key:'name',          
            label:'Name',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'date',          
            label:'Date',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]
    
    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];    

    state = {
        firstAppellant: null,
        firstRespondent: null,
        filingParties: null,
        hearingLocation: null,
        hearingLocationOther: null,
        hearingDate: null,
        hearingTime: null,    
        affidavitList: null,
        applicationContested: null, 
        relyingSectionRule: null,
        orderList: null,
        filedMaterial: null,
        materialList: null,         
        authorizedName:null
    }  

    mounted() {
        this.dataReady = false;
        this.extractInfo();              
    }

    public extractInfo(){ 

        this.hearingLocationList = [];
        
        for (const hearingLocation of this.hearingLocationsInfo){
            if (hearingLocation.other){
                this.otherHearingLocationList.push(hearingLocation.name);
            } else {
                this.hearingLocationList.push(hearingLocation.name);    
            }           
        }

        this.hearingLocationList.push('Other');        

        if(this.currentNoticeOfUrgentApplicationId){
            this.getForm7Data();           
        } else {   
            
            const form7Data = {} as form7DataInfoType;

            form7Data.appellants = this.partiesJson.appellants
            form7Data.respondents = this.partiesJson.respondents;
            form7Data.formSevenNumber = this.fileNumber;            
            form7Data.hearingTime = '10:00:00';
            form7Data.affidavitList = [];
            form7Data.version = this.$store.state.Application.version;             
           
            this.UpdateForm7Info(form7Data);                       
            this.saveForm(true);
        }

    }

    public closeAffidavitForm() {                     
        this.AddNewAffidavitForm= false; 
        this.addAffidavitFormColor = 'court'
        if(this.isEditAffidavitOpen){
            this.latestEditAffidavitData.toggleDetails();
            this.isEditAffidavitOpen = false;
        } 
    }

    public addNewAffidavit(){
        this.state.affidavitList= null
        if(this.isEditAffidavitOpen){            
            this.addAffidavitFormColor = 'danger'
        }else{
            this.AddNewAffidavitForm = true;            
        }
    }

    public editAffidavit(data) {
        if(this.AddNewAffidavitForm || this.isEditAffidavitOpen){            
            this.addAffidavitFormColor = 'danger';                     
        }else if(!this.isEditAffidavitOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditAffidavitOpen = true;
            this.latestEditAffidavitData = data            
        }   
    }

    public modifyAffidavitList(isCreateAffidavit: boolean, newAffidavit: affidavitInfoType, index: number){        

        if (isCreateAffidavit){
            
            const form7Data = this.form7Info;
            if(!form7Data.affidavitList) form7Data.affidavitList=[];
            form7Data.affidavitList.push(newAffidavit);            
            this.UpdateForm7Info(form7Data);
            this.closeAffidavitForm();

        } else { 
            
            const form7Data = this.form7Info;
            form7Data.affidavitList[index].date = newAffidavit.date;
            form7Data.affidavitList[index].name = newAffidavit.name;
           
            this.UpdateForm7Info(form7Data);
                      
            this.closeAffidavitForm();
        }
        this.updated ++;
    }

    public removeAffidavit(data){ 
        const form7Data = this.form7Info;       
        form7Data.affidavitList.splice(data.index,1);        
        this.UpdateForm7Info(form7Data);
        this.updated ++;        
    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];

        for (const respondent of this.form7Info.respondents){
            this.respondentNames.push(respondent.name); 
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form7Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);  
        }
     
        this.dataReady = true;

    }

    public updateLocation(){ 
              
        const form7 = this.form7Info;        
        form7.hearingLocation = {} as hearingLocationsInfoType;
       
        if (this.hearingLocation == 'Other' && this.otherHearingLocation.length > 0){
            form7.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.otherHearingLocation)[0]
        } else if (this.hearingLocation != 'Other') {
            form7.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.hearingLocation)[0]
        }          
          
        this.UpdateForm7Info(form7);
        this.recheckStates()
    }

    public getForm7Data() {        
       
        this.$http.get('/form7/forms/'+this.currentNoticeOfUrgentApplicationId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form7Data = response.data.data
                this.UpdateForm7Info(form7Data);
                if (form7Data.hearingLocation?.name){

                    if (this.hearingLocationList.includes(form7Data.hearingLocation.name)){
                        this.hearingLocation = form7Data.hearingLocation.name;
                        this.otherHearingLocation = '';            
                    } else {
                        this.hearingLocation = 'Other';
                        this.otherHearingLocation = form7Data.hearingLocation.name;            
                    }

                } else {
                    this.hearingLocation = '';
                    this.otherHearingLocation = '';
                } 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,
            filingParties: null,
            hearingLocation: null,
            hearingLocationOther: null,
            hearingDate: null,
            hearingTime: null,    
            affidavitList: null,
            applicationContested: null, 
            relyingSectionRule: null,
            orderList: null,
            filedMaterial: null,
            materialList: null,         
            authorizedName:null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   
        
        this.state.firstAppellant = !this.form7Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form7Info.firstRespondent? false : null; 
        this.state.filingParties = this.form7Info.filingParties?.length>0? null :false;
        this.state.hearingLocation = this.hearingLocation? null: false;
        this.state.hearingLocationOther = (this.hearingLocation=='Other' && !this.otherHearingLocation) ?false: null

        this.state.hearingDate = this.form7Info.hearingDate && this.allowedDates(this.form7Info.hearingDate)? null :false;
        this.state.hearingTime = this.form7Info.hearingTime? null :false;
        this.state.affidavitList = this.form7Info.affidavitList?.length > 0? null :false;
        this.state.filedMaterial = this.form7Info.filedMaterial != null ? null : false;
        this.state.applicationContested = this.form7Info.applicationContested == null ? false : null;
        this.state.relyingSectionRule = !this.form7Info.relyingSectionRule ? false : null;
        this.state.orderList = this.form7Info.orderList?.length > 0 ? null : false  
        this.state.materialList = this.form7Info.filedMaterial && !this.form7Info.materialList? false: null;
        this.state.authorizedName = !this.form7Info.authorizedName? false : null;       

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }            
        }
        return true            
    }    

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form7/forms';

        if (this.currentNoticeOfUrgentApplicationId){
            method = 'put';
            url = '/form7/forms/'+this.currentNoticeOfUrgentApplicationId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form7Info,
                    type:'Form7',
                    description:'Notice of Urgent Application'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form7Info,
                    type:'Form7',
                    description:'Notice of Urgent Application'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfUrgentApplicationId(response.data.file_id);
                        this.extractPartiesData();    
                        const data = this.form7Info;  
                        this.UpdateForm7Info(data)                  
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');           
        return (date >= day);           
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form7"}) 
    }

}
